angular.module('mobilezuz').controller('PaymentIFrameDialogCtrl', [
    '$scope', '$rootScope', '$timeout', '$sce', 'Config', 'Util', 'Loading', 'mDesign', 'Retailer', 'options',
    function ($scope, $rootScope, $timeout, $sce, Config, Util, Loading, mDesign, Retailer, options) {
        var paymentIFrameCtrl = this,
            _iFrameId = 'payment_iframe',
            _iFrameInitiated = false,
            _listeners = [],
            _iframeTimeOut,
            _loadingTimeOut,
            _iframeLoadTimeOut;

        paymentIFrameCtrl.iFrameUrl = $sce.trustAsResourceUrl(options.url);
        paymentIFrameCtrl.paymentMethodId = options.paymentMethodId;
        paymentIFrameCtrl.isAddCard = options.isAddCard;
        paymentIFrameCtrl.iFrameLoaded = false;
        paymentIFrameCtrl.cancel = mDesign.cancel;
        paymentIFrameCtrl.bindIFrameLoad = bindIFrameLoad;

        if (options && options.isLoyalty && Config.retailer.loyaltyClubDriver) {
            paymentIFrameCtrl.loyaltyClubDriver = Config.retailer.loyaltyClubDriver;
        }

        /**
         * Start loading image for iFrame and bind on load event to iFrame
         */
        function bindIFrameLoad() {
            if (_iFrameInitiated) {
                return;
            }

            _iframeTimeOut = $timeout(function() {
                if (_iFrameInitiated) {
                    return;
                }

                var iFrameElement = document.getElementById(_iFrameId);
                if (!iFrameElement) {
                    bindIFrameLoad();
                    return;
                }

                _iFrameInitiated = true;
                Loading.counter(null, 1);
                angular.element(iFrameElement).bind('load', _onIFrameLoad);
                _loadingTimeOut = $timeout(function() {
                    _onIFrameLoad({ target: iFrameElement }, true);
                }, 60000);
                _listeners.push($rootScope.$on('init_cart_iframe_redirect.finished', _setIframeLoaded));
                _listeners.push($rootScope.$on('init_cart_iframe_redirect.loaded', _setIframeLoaded));
                _onIFrameLoad({ target: iFrameElement });
            }, 100);
        }

        /**
         * Stop loading image for iFrame and unbind on load event
         * @private
         *
         * @param {Event} event
         * @param {boolean} [isTimeout]
         */
        function _onIFrameLoad(event, isTimeout) {
            Retailer.getRetailerMainDomain()
                .then(function(appDomain) {
                    if (isTimeout) {
                        throw 'Loading timeout';
                    }

                    var toTryAccessIFrame = event.target.contentWindow.location.origin;
                    if (!toTryAccessIFrame || toTryAccessIFrame.indexOf('http') !== 0) {
                        return;
                    }

                    if (appDomain === '/') {
                        appDomain = window.location.origin;
                    }
                    if (!toTryAccessIFrame.startsWith(appDomain)) {
                        throw 'Set as loaded';
                    }
                })
                .catch(function () {
                    _setIframeLoaded();
                });
        }

        function _setIframeLoaded() {
            if (paymentIFrameCtrl.iFrameLoaded) {
                return;
            }

            if (_loadingTimeOut) {
                $timeout.cancel(_loadingTimeOut);
            }

            _iframeLoadTimeOut = $timeout(function() {
                paymentIFrameCtrl.iFrameLoaded = true;
                Loading.counter(null, -1);

                var iFrameElement = document.getElementById(_iFrameId);
                if (!iFrameElement) {
                    return;
                }

                angular.element(iFrameElement).unbind('load', _onIFrameLoad);
                iFrameElement === document.activeElement && iFrameElement.blur();
                angular.element(iFrameElement).removeClass('hidden');
            }, 0);
        }

        _listeners.push(function() {
            // cancel loading when dialog closes
            if (_iFrameInitiated && !paymentIFrameCtrl.iFrameLoaded) {
                Loading.counter(null, -1);
            }

            // cancel timeouts
            _iframeTimeOut && $timeout.cancel(_iframeTimeOut);
            _loadingTimeOut && $timeout.cancel(_loadingTimeOut);
            _iframeLoadTimeOut && $timeout.cancel(_iframeLoadTimeOut);
        });

        Util.destroyListeners($scope, _listeners);
    }]);
